import { render, staticRenderFns } from "./MeloLives.vue?vue&type=template&id=6bc38a26"
import script from "./MeloLives.vue?vue&type=script&lang=js"
export * from "./MeloLives.vue?vue&type=script&lang=js"
import style0 from "./MeloLives.vue?vue&type=style&index=0&id=6bc38a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports